<template>
  <div>
    <div style="text-align:right">

      <!-- <input @change="refresh()" type="checkbox" id="isOnlyCompleted" v-model="isOnlyCompleted">
      <label for="isOnlyCompleted">alleen afgeronde orders</label> -->

      <input @change="setVat(), refresh()" type="checkbox" id="isIncVat" v-model="isIncVat">
      <label for="isIncVat">inclusief b.t.w.</label>

      <select @change="refresh()" v-model="period">
        <option v-for="(months, period) in periodArray" v-bind:key="period">{{ period }}</option>
      </select>

       <div v-if="!period.includes('Vorig')" style="display:inline">
          <input @change="refresh()" type="checkbox" id="isUpToToday" v-model="isUpToToday">
          <label for="isUpToToday">tot vandaag</label>
        </div>

    </div>
    <h2 class="content-heading">
      <i class="si si-tag mr-5"></i> Producten {{ (period === "Dit jaar" ? "in dit jaar t.o.v. vorig jaar" : "in " + period.toLowerCase() + " van dit jaar t.o.v. van vorig jaar") }}
    </h2>

    <api-table-block ref="productsTable" :fields="fields" :items="findAllProducts" default-sort-by="total_revenue" item-label-singular="product" item-label-plural="producten">

      <!-- <template slot="image" slot-scope="data">
        <img class="img-avatar img-avatar48" :src="data.item.image_urls[0]" :key="data.item.id" alt="">
      </template> -->

      <template slot="name" slot-scope="data">
        {{data.value}}
      </template>
     
      <!-- <template slot="price" slot-scope="data">
        {{Number(data.value) | money}}
      </template> -->

      <template slot="total_revenue" slot-scope="data">
        {{correction * Number(data.value) | money}}
        <b><small v-bind:class="data.item.improvement_revenue >= 0 ? 'text-success' : 'text-danger'">{{data.item.improvement_revenue}}{{ data.item.improvement_revenue ? '%' : '' }}</small></b>
      </template>


      <template slot="total_revenue_last_year" slot-scope="data">
        {{(data.value ? correction * Number(data.value) : '') | money}}
      </template>


      <template slot="total_sold" slot-scope="data">
        {{ Number(data.value) }}
        <b><small v-bind:class="data.item.improvement_sold >= 0 ? 'text-success' : 'text-danger'">{{data.item.improvement_sold}}{{ data.item.improvement_sold ? '%' : '' }}</small></b>
      </template>

      <template slot="total_sold_last_year" slot-scope="data">
        {{ data.value? Number(data.value) : '' }}
      </template>

    </api-table-block>
  </div>
</template>

<script>
import http from '../utils/http'
import ApiTableBlock from '../common/ApiTableBlock'
import dataBlock from './dataBlock.js'
export default {
  components: {
    ApiTableBlock
  },
  data () {
    return dataBlock
  },
  methods: {
    findAllProducts (params) {
      return http.get('/report-products/' + this.periodArray[this.period] + '/' + this.isUpToToday + '/' + this.isOnlyCompleted, { params })
      .catch(error => {
        console.log(error)
      })
      .then((result) => {
        console.log(result)
        return result
      })
    },
    setVat () {
      if (this.isIncVat === false) {
        this.correction = 1 / 1.21
      } else {
        this.correction = 1
      }
    },
    refresh () {
      this.$refs.productsTable.refresh()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReportProductsPage.vue?9d98083e